import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import StyledMessage from './styled/message'
import Content from './components/Content'

const Message = (props) => {
  const {
    styledType = 'default',
    icon,
    title,
    description,
    position,
    style,
    className,
    backgroundColor,
    borderColor,
    textColor,
    fontSize,
    onClose,
    children,
    type,
  } = props

  return (
    <StyledMessage
      data-id="message-element"
      styledType={styledType}
      className={clsx([
        {
          // 暂时注释
          // 'bg-primary-50': !backgroundColor,
          'text-primary': !textColor,
        },
        className,
      ])}
      style={style}
      textColor={textColor}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      fontSize={fontSize}
      position={position}
    >
      <Content
        styledType={styledType}
        icon={icon}
        title={title}
        description={description}
        borderColor={borderColor}
        textColor={textColor}
        onClose={onClose}
        type={type}
      >
        {children}
      </Content>
    </StyledMessage>
  )
}

// 参数类型
Message.propTypes = {
  styledType: PropTypes.string,
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  position: PropTypes.oneOf([
    'top left',
    'top center',
    'top right',
    'bottom left',
    'bottom center',
    'bottom right',
  ]),
  style: PropTypes.shape,
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  textColor: PropTypes.string,
  fontSize: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.shape]),
}

Message.defaultProps = {
  styledType: 'default',
  icon: undefined,
  title: undefined,
  type: 'info',
  description: undefined,
  position: 'top left',
  style: {},
  className: undefined,
  backgroundColor: undefined,
  borderColor: undefined,
  textColor: undefined,
  fontSize: undefined,
  onClose: undefined,
  children: undefined,
}
export default Message
